import { render } from "./Featured.vue?vue&type=template&id=a3c15fae&ts=true"
import script from "./Featured.vue?vue&type=script&lang=ts"
export * from "./Featured.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__